import { render, staticRenderFns } from "./eventConfigNew.vue?vue&type=template&id=639e4008&"
import script from "./eventConfigNew.vue?vue&type=script&lang=js&"
export * from "./eventConfigNew.vue?vue&type=script&lang=js&"
import style0 from "./eventConfigNew.vue?vue&type=style&index=0&id=639e4008&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports